import React from 'react';
import { Image as ImageUI } from '@spothero/ui-backlog';
import useConfig from 'hooks/use-config';
const Image = (props) => {
    const { cloudinaryCloudName } = useConfig();
    return <ImageUI cloudinaryCloudName={cloudinaryCloudName} {...props}/>;
};
export default Image;
